<div
    class="sd-container"
    [ngClass]="{
        'sd-when-where': isOnDayPackagePage,
        'not-visible': !showFullSize || !showCTAOnPage,
    }"
>
    <div class="sd-use-hotel-search">
        <img
            [src]="'assets/img/home/use-hotel-search.gif'"
            style="width: 250px"
        />
    </div>
    <div class="sd-bubble">
        <div class="sd-where-to">{{ "Where to?" | translate }}</div>

        <div class="date-picker-area">
            <div
                class="sd-date-picker"
                *ngIf="!isOnDayPackagePage; else singleCalendar"
            >
                <md-calendar
                    #calendarSearchDates
                    [isCalendarPopupBelow]="true"
                    [notAvailabilityBased]="true"
                    (dateRangeSelected)="onDateRangeSelected($event)"
                    [showDesktopInPopup]="true"
                    [showSelectionSummary]="false"
                    [showResetInFooter]="true"
                    [isSingleDate]="false"
                    [darkBackgroundOnOpen]="isScrolled"
                    ><div popupTargetControl class="sd-date-picker-inside">
                        <div class="sd-date-picker-in sd-date-picker-common">
                            <ion-icon name="calendar-clear-outline"></ion-icon>
                            <span
                                class="sd-date-picker-chkin sd-date-picker-text"
                                >{{ "Check-in" | translate }}</span
                            >
                            <span>{{ formattedFromDate }}</span>
                        </div>
                        <div class="sd-date-divider"></div>
                        <div class="sd-date-picker-out sd-date-picker-common">
                            <ion-icon name="calendar-clear-outline"></ion-icon>
                            <span
                                class="sd-date-picker-chkout sd-date-picker-text"
                                >{{ "Check-out" | translate }}</span
                            >
                            <span>{{ formattedToDate }}</span>
                        </div>
                        <div class="sd-date-divider"></div>
                    </div>
                </md-calendar>
            </div>
            <div
                class="sd-occup"
                *ngIf="!isOnDayPackagePage; else locationControl"
            >
                <md-search-occupancy
                    #searchOccupancy
                    (occupancyChanged)="onOccupancyChanged($event)"
                    (mobileOccupancyClosed)="onMobileOccupancySearchClick()"
                    [darkBackgroundOnOpen]="isScrolled"
                    [initialOccupancy]="selectedOccupancy"
                >
                    <div
                        targetControl
                        class="sd-occup-inside"
                        (click)="onOccupancyClicked()"
                    >
                        <ion-icon name="person-outline"></ion-icon>
                        <span class="sd-occup-guests">{{
                            "Guests" | translate
                        }}</span>
                        <span class="sd-occup-value">{{
                            occupancyString | translate
                        }}</span>
                    </div>
                </md-search-occupancy>
            </div>
        </div>
        <button class="sd-button" (click)="search()">
            <span>{{ "Search" | translate }}</span>
        </button>
    </div>
</div>
<div class="sd-h-container" *ngIf="!showFullSize">
    <div class="sd-date-guests-mobile-inner">
        <md-popup-offcanvas
            #mobileCTAOffcanvas
            [mobileContinueButtonText]="'Search' | translate"
            [mobileContinueButtonClick]="onMobileOccupancySearchClick"
            [darkBackgroundOnOpen]="true"
            [mobileSecondaryButtonText]="'Clear all' | translate"
            [mobileSecondaryButtonClick]="clearAll"
            [mobileSecondaryButtonVisible]="true"
            [fixedSize]="false"
        >
            <div actualControl select="[actualControl]" class="c-o-container">
                <div
                    (click)="openCalendar()"
                    class="sd-date-guests-mobile-item"
                >
                    <span>{{ "When" | translate }}</span
                    ><span>{{
                        isOnDayPackagePage
                            ? formattedSingleDate
                            : formattedMobileDates
                    }}</span>
                </div>
                <div
                    class="sd-date-guests-mobile-item"
                    (click)="onWhoWhereClicked()"
                >
                    <span>{{
                        (isOnDayPackagePage ? "Where" : "Who") | translate
                    }}</span
                    ><span>{{
                        isOnDayPackagePage ? locationString : occupancyString
                    }}</span>
                </div>
            </div>
            <div
                targetControl
                class="sd-date-guests-mobile-inside"
                (click)="onMobileCTAOffcanvasOpen()"
            >
                {{
                    (isOnDayPackagePage
                        ? formattedSingleDate
                        : formattedMobileDates) +
                        " • " +
                        (isOnDayPackagePage ? locationString : occupancyString)
                }}
            </div>
        </md-popup-offcanvas>
    </div>
</div>
<ng-template #singleCalendar>
    <div class="sd-date-picker">
        <md-calendar
            [isCalendarPopupBelow]="true"
            #calendarSingleSearchDates
            [notAvailabilityBased]="true"
            (dateRangeSelected)="onSingleDateSelected($event)"
            [showDesktopInPopup]="true"
            [darkBackgroundOnOpen]="false"
            [isSingleDate]="true"
            ><div popupTargetControl class="sd-date-picker-inside">
                <div class="sd-date-picker-in sd-date-picker-common">
                    <ion-icon name="calendar-clear-outline"></ion-icon>
                    <span class="sd-date-picker-chkin sd-date-picker-text">{{
                        "When" | translate
                    }}</span>
                    <span>{{ formattedSingleDate }}</span>
                </div>
            </div>
        </md-calendar>
    </div>
</ng-template>
<ng-template #locationControl>
    <md-search-location
        #searchLocation
        (locationChanged)="onLocationChanged($event)"
        class="sd-occup"
    >
        <div
            targetControl
            class="sd-occup-inside"
            (click)="onLocationClicked()"
        >
            <ion-icon name="location-outline"></ion-icon>
            <span class="sd-occup-guests">{{ "Where" | translate }}</span>
            <span class="sd-occup-value">{{ locationString | translate }}</span>
        </div>
    </md-search-location>
</ng-template>
